import { combineReducers, idleState, failedState, loadingState } from '@grandvisionhq/state';
import { prescriptionsReducer, initialState as initialState$3 } from './Prescriptions/state/reducer.js';
import { profileReducer, initialState as initialState$1 } from './Profile/reducer.js';
import { subscriptionsReducer, initialState as initialState$2 } from './Subscriptions/reducer.js';
import { unlinkOrderFailed, unlinkOrderSuccess, unlinkOrder } from './Unlink/actions.js';

const initialState = {
    profile: initialState$1,
    subscriptions: initialState$2,
    prescriptions: initialState$3,
    unlinkOrderCall: idleState()
};
const unlinkOrderReducer = (state = initialState.unlinkOrderCall, action)=>{
    switch(action.type){
        case unlinkOrder.type:
            return loadingState();
        case unlinkOrderSuccess.type:
            return idleState();
        case unlinkOrderFailed.type:
            return failedState(action.error);
        default:
            return state;
    }
};
var reducer = combineReducers({
    profile: profileReducer,
    subscriptions: subscriptionsReducer,
    prescriptions: prescriptionsReducer,
    unlinkOrderCall: unlinkOrderReducer
});

export { reducer as default, initialState };
//# sourceMappingURL=reducer.js.map
